/** vuex store for themes manager module  */
export const themesManager = {
  namespaced: true,
  /** state (data) */
  state: () => ({
    themes: [], // handles the fetched themes from the api
    indicators: [], // handles the fetched indicators from the api
    selectedThemeId: null, // track selected theme id so we know what to add indicators to
    selectedThemeName: "", // useful for reminding the user what theme they are working on
    addingIndicatorToTheme: false, // track if the user is adding an indicator to a theme
  }),
  /** setters */
  mutations: {
    setThemes(state, value) {
      state.themes = value;
    },
    setIndicators(state, value) {
      state.indicators = value;
    },
    setSelectedThemeId(state, value) {
      state.selectedThemeId = value;
    },
    setSelectedThemeName(state, value) {
      state.selectedThemeName = value;
    },
    setAddingIndicatorToTheme(state, value) {
      state.addingIndicatorToTheme = value;
    },
  },
  /** getters */
  getters: {
    themes: (state) => state.themes,
    indicators: (state) => state.indicators,
    selectedThemeId: (state) => state.selectedThemeId,
    selectedThemeName: (state) => state.selectedThemeName,
    addingIndicatorToTheme: (state) => state.addingIndicatorToTheme,
  },
};
